<div class="container py-4">

  <!-- 🔷 TÍTULO -->
 

  <!-- 🟥 BANNER -->
  <div class="banner-ia">
    <div class="banner-left">
      <img src="assets/banners_carreras/EFECTOS.jpg" alt="IA">
    </div>
  </div>

  <!-- 📘 INFO PRINCIPAL -->
  <section class="info-section">

    <div class="info-block">
      <h3>■ OBJETIVO GENERAL</h3>
      <p>
        Formar Ingenieros en Animación Digital y Efectos Visuales capaces de comprender, adaptar y desarrollar recursos tecnológicos dentro de las industrias del entretenimiento y medios digitales; aplicando arte, tecnología y narrativa para la resolución creativa de problemas dentro en un contexto profesional, global, multidisciplinario y sustentable.
      </p>
    </div>

    <div class="info-block">
      <h3>■ MISIÓN</h3>
      <p>
       Formar profesionales en Animación Digital y Efectos Visuales con una preparación integral que combine arte, tecnología y narrativa, fomentando la innovación, la ética y la responsabilidad social. Contribuir al desarrollo de las industrias del entretenimiento y los medios digitales, mediante la creación de soluciones creativas y sustentables que respondan a las necesidades locales, regionales y globales, impulsando la colaboración multidisciplinaria y el crecimiento cultural y económico de la sociedad.
      </p>
    </div>

     <div class="info-block">
      <h3>■ VISIÓN</h3>
      <p>
      Ser un programa educativo reconocido a nivel nacional e internacional por la excelencia académica y la innovación en la formación de ingenieros en Animación Digital y Efectos Visuales. Destacarse como referente en la creación de talento capaz de liderar proyectos tecnológicos, artísticos y narrativos en la industria digital, aportando soluciones que integren creatividad, vanguardia tecnológica y responsabilidad social, en beneficio del desarrollo cultural y profesional en un contexto global.
      </p>
    </div>

  </section>

  <!-- 🧠 TABS -->
  <div class="tabs-box">

    <ul class="nav nav-tabs">
      <li class="nav-item">
        <button class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab1">
          1. Perfil de Ingreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab2">
          2. Perfil de Egreso
        </button>
      </li>

      <li class="nav-item">
        <button class="nav-link" data-bs-toggle="tab" data-bs-target="#tab3">
          3. Atributos de Egreso
        </button>
      </li>

     
     
    </ul>

    <div class="tab-content">

      <!-- TAB 1 -->
      <div id="tab1" class="tab-pane fade show active">
        <P>El aspirante a la carrera de Ingeniería en Animación Digital y Efectos Visuales deberá mostrar:</P>
        <ul>
          <li>Interés por el arte digital, la narrativa audiovisual y el uso de la tecnología como medio de expresión y desarrollo profesional. </li>
          <li>Creatividad, imaginación y disposición para la innovación en proyectos artísticos y tecnológicos. </li>
          <li>Habilidades básicas en el manejo de equipos de cómputo, así como disposición para aprender herramientas digitales y software especializado</li>
          <li>Capacidad de observación, análisis y síntesis para la resolución de problemas </li>
          <li>Gusto por el trabajo colaborativo y apertura a la integración en equipos multidisciplinarios.</li>
          <li>Valores de responsabilidad, compromiso y ética, que permitan desempeñarse en un entorno académico y profesional.</li>
          <li>. Conocimientos generales de matemáticas, física y comunicación, que sirvan de base para el desarrollo de competencias en programación, modelado y simulación.</li>
        </ul>
      </div>

      <!-- TAB 2 -->
      <div id="tab2" class="tab-pane fade">
        <p>El egresado de la carrera de Ingeniería en Animación Digital y Efectos Visuales: </p>
        <ul>
          <li>Crear gráficas diseñadas por ordenador (CGI) de calidad utilizando software especializado </li>
          <li>Aplica, identifica y genera recursos artísticos, para el desarrollo de proyectos dentro de las industrias del entretenimiento y medios digitales. </li>
          <li>Analiza y sintetiza ideas narrativas para que en colaboración con un equipo multidisciplinario de trabajo sea capaz comunicar efectivamente con diferentes audiencias.</li>
          <li>Desarrolla, colabora y organiza planes de trabajo dentro de una producción de equipos multidisciplinarios para generar un producto de calidad. </li>
          <li>Interpreta datos e implementa procesos de programación enfocada a gráficos computacionales CGI y diseño de videojuegos.</li>
          <li>Reconoce necesidades dentro de los negocios de las industrias digitales; organiza, administra y emprende proyectos de innovación. </li>
          <li>Domina procesos lógico-matemáticos, físicos y estructurales para la simulación aplicada a entornos gráficos computacionales</li>
          <li>Aplica modelos psicológicos funcionales para el desarrollo profesional.</li>
          <li>Aplica la ética y responsabilidad social a su trabajo profesional.</li>
        </ul>
      </div>

      <!-- TAB 3 -->
      <div id="tab3" class="tab-pane fade">
        <ul>
          <li>Contenido pendiente...</li>
        </ul>
      </div>

     

    </div>
  </div>

  <!--DOCUMENTACIÓN -->
  <div class="doc-section text-center">
    <img src="assets/banners_carreras/logo_drive.png" class="doc-icon">
    <br>
    <a href="https://drive.google.com/drive/folders/18XG7SklYHFxkXBk55N5sKpuHtc5SbqlI" 
       target="_blank" 
       class="doc-link">
       ■ DOCUMENTACIÓN INGENIERÍA EN ANIMACION DIGITAL Y EFECTOS VISUALES
    </a>
  </div>

  <hr>


  <div class="btn-section">

    <a href="assets/reticulas/1. RETICULA TECNM animacion.pdf" target="_blank" class="btn-doc">
      📊 Retícula
    </a>
  </div>

  <!-- 👤 CONTACTO (AL FINAL 🔥) -->
  <section class="contact-section">

    <div class="contact-row">

      <div class="contact-card">
        <h3>■ JEFE DE DIVISIÓN</h3>
        <p class="name">Carlos Enrique Ávila Pérez</p>
        <p>E-mail: <a href="mailto:divisioniad@itsescarcega.edu.mx">divisioniad@itsescarcega.edu.mx</a></p>
        <P> Telefono:9821255983 </P>
      </div>

   <!--    <div class="contact-card">
        <h3>■ COORDINADORA</h3>
        <p class="name">Lic. Jazmín Solis Rebolledo</p>
        <p>E-mail: <a href="mailto:coordinacionisc@itsescarcega.edu.mx">coordinacionisc@itsescarcega.edu.mx</a></p>
        <p> Telefono:9821047765</p>
      </div> -->

    </div>

  </section>

</div>